import { createContext, useContext, useEffect } from 'react';
import useAsync from '../hooks/async';
import { getClients } from '../api/services/clients';

const ListsContext = createContext();
ListsContext.displayName = 'ListsContext';

export function ListsProvider({ children }) {
  const clients = useAsync();
  const { run: runClients } = clients;

  useEffect(() => {
    runClients(getClients());
  }, [runClients]);

  const value = { clients };

  return (
    <ListsContext.Provider value={value}>{children}</ListsContext.Provider>
  );
}

export function useLists() {
  const context = useContext(ListsContext);
  if (!context) {
    throw new Error('useLists must be used within a ListsProvider');
  }
  return context;
}
